import { List, ListItem, ListItemText, Skeleton } from '@mui/material';
import styles from './FrequentUpdates.module.scss';

export const JobsListSkeleton = () => {
  return (
    <List>
      {[...Array(3)].map((_, index) => (
        <ListItem key={index} className={styles.jobItem}>
          <ListItemText
            primary={<Skeleton width="30%" />}
            secondary={<Skeleton width="60%" />}
          />
        </ListItem>
      ))}
    </List>
  );
};
